<script>
import { mapGetters } from 'vuex';
import { debounce } from '@chatwoot/utils';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        attachments: cannedMessage.files,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses = debounce(() => {
      this.$store.dispatch('getCannedResponse', {
        searchKey: this.searchKey,
      });
    }, 300);
    this.fetchCannedResponses();
  },
  methods: {
    handleMentionClick(item = {}) {
      this.$emit('click', item.description);
      this.$emit('insertAttachments', item.attachments);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mentionSelect="handleMentionClick"
  />
</template>
